module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion', {
    ref: "accordion",
    staticClass: "paddingBottom eventsList",
    attrs: {
      "injected": _vm.injected,
      "container": "#body",
      "thresold": 50,
      "sort-by": ['event.startTime']
    }
  }, [(_vm.eventsListStatus == _vm.STATUS.LOADED && _vm.eventsListCanLoadPrevious) ? [_c('accordion-loading-header', {
    staticClass: "inPast",
    attrs: {
      "thresold": 40
    },
    on: {
      "fire": _vm.loadPrevious,
      "click": _vm.loadPrevious
    }
  }, [_vm._v(_vm._s(_vm.$t("events.loadingPrevious"))), (_vm.eventsList.length > 0) ? _c('span', [_vm._v("  (" + _vm._s(_vm.$t("events.loadedUntil")) + " " + _vm._s(_vm.eventsList[0].startTimeStr) + ")")]) : _vm._e()])] : _vm._e(), (_vm.eventsListStatus == _vm.STATUS.LOADED && !_vm.eventsListCanLoadPrevious) ? [_c('div', {
    staticClass: "information-message"
  }, [_vm._v(_vm._s(_vm.$t("events.allPreviousLoaded")))])] : _vm._e(), (_vm.eventsListStatus == _vm.STATUS.LOADING) ? _c('accordion-loading-header', {
    staticClass: "afterHeaderMargin",
    on: {
      "fire": _vm.doNothing
    }
  }, [_vm._v(_vm._s(_vm.$t("events.loading")))]) : _vm._e(), (_vm.eventsListStatus == _vm.STATUS.LOADED) ? [(_vm.eventsList.length == 0) ? [_c('h2', [_c('small', [_vm._v(_vm._s(_vm.$t("events.noEvents")))])]), _c('i', {
    staticClass: "fa fa-hand-pointer-o plusPointer"
  })] : [_vm._l((_vm.eventsByMonth), function(monthAndEvents, index) {
    return [(monthAndEvents.now && index != 0) ? _c('hr') : _vm._e(), _c('accordion-subtitle', {
      attrs: {
        "group": "monthHeader"
      }
    }, [(monthAndEvents.nearly) ? [_vm._v(_vm._s(_vm.$t('events.nearly.' + monthAndEvents.month)))] : [_vm._v(_vm._s(_vm._f("ucfirst")(_vm._f("monthYear")(monthAndEvents.elems[0].startTime * 1000))))]], 2), _vm._l((monthAndEvents.elems), function(event) {
      return _c('detailled-event', {
        key: event.id,
        attrs: {
          "event": event,
          "initial-active": _vm.active,
          "initial-stay-active": _vm.stayActive,
          "injected": _vm.injected
        },
        on: {
          "asktoclose": function($event) {
            return _vm.removeEvent(event)
          }
        }
      })
    })]
  })], (_vm.eventsListCanLoadMore) ? [_c('h2'), _c('accordion-loading-header', {
    on: {
      "fire": _vm.loadNext
    }
  }, [_vm._v(_vm._s(_vm.$t("events.loadingNext")))])] : [_c('h2'), _c('div', {
    staticClass: "information-message"
  }, [_vm._v(_vm._s(_vm.$t("events.allNextLoaded")))])]] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54e6a219","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/Events-List.vue
// module id = 883
// module chunks = 13